import { createSlice } from "@reduxjs/toolkit";

const mySlice = createSlice({
  name: "Category",
  initialState: {
    isFetching: false,
    all: { data: [] },
    selected: null,
  },
  reducers: {
    setIsFetching(state, action) {
      state.isFetching = action.payload;
    },
    setSelected(state, action) {
      state.selected = action.payload;
    },
    setAll(state, action) {
      state.all = action.payload;
    },
  },
});

export const myCategoryActions = mySlice.actions;

export default mySlice.reducer;
